module.exports = __webpack_public_path__ + "img/f_logo_border.a11ff6d8.png";